/**
 * Языки проекта (capability localization). Добавить язык: каталоги `locales/<code>/*.json`,
 * строка здесь и импорт ресурсов в `src/lib/i18n.ts`.
 * Название — самоназвание языка, не переводится: человек ищет свой язык, написанный на нём самом.
 *
 * Один язык на страну акции (код языка ISO 639-1, не код страны — отличается у `by`→`be`, `ge`→`ka`, `md`→`ro`):
 * ru — Россия, az — Азербайджан, be — Беларусь, ka — Грузия, ky — Киргизия,
 * kk — Казахстан, ro — Молдова, tg — Таджикистан, uz — Узбекистан.
 */
export const SUPPORTED_LANGUAGES = [
  { code: 'ru', name: 'Русский' },
  { code: 'az', name: 'Azərbaycanca' },
  { code: 'be', name: 'Беларуская' },
  { code: 'ka', name: 'ქართული' },
  { code: 'ky', name: 'Кыргызча' },
  { code: 'kk', name: 'Қазақша' },
  { code: 'ro', name: 'Română' },
  { code: 'tg', name: 'Тоҷикӣ' },
  { code: 'uz', name: "O'zbekcha" },
] as const;

export type LanguageCode = (typeof SUPPORTED_LANGUAGES)[number]['code'];

export const DEFAULT_LANGUAGE: LanguageCode = 'ru';

/** Непустой кортеж — годится для `z.enum`. */
export const LANGUAGE_CODES = SUPPORTED_LANGUAGES.map((l) => l.code) as [LanguageCode, ...LanguageCode[]];

/** Языки, для которых заводится перевод данных (каталог призов): все, кроме базового `ru`. */
export const TRANSLATABLE_LANGUAGE_CODES = LANGUAGE_CODES.filter((c) => c !== DEFAULT_LANGUAGE) as
  [Exclude<LanguageCode, 'ru'>, ...Exclude<LanguageCode, 'ru'>[]];
